import * as React from 'react';
import { FunctionComponent } from 'react';
import KsimOverview from './KsimOverview';
import { Box, Typography } from '@mui/material';
import { GetResponsiveWidth } from '../../common/TabsComponent';
import { useResponsive } from '../../../contexts/ResponsiveContext';
import { SalesAndResourcesSimulationToolsOverviewPreBuiltProjectsContent } from '../../../graphql/pimcore/modules/siteContent/types/SalesAndResourcesSimulationToolsContent';

interface KsimSectionProps {
    cmsContent: SalesAndResourcesSimulationToolsOverviewPreBuiltProjectsContent;
}

const KsimSection: FunctionComponent<KsimSectionProps> = ({ cmsContent }) => {
    const { isScreenMd, isScreenSm, isScreenXs } = useResponsive();

    return (
        <Box sx={{ width: '100%', backgroundColor: '#F8F8F8' }}>
            <Box
                sx={{
                    width: GetResponsiveWidth(),
                    display: 'flex',
                    margin: 'auto',
                    flexDirection: 'column',
                }}
            >
                <Typography
                    data-testid={'ksim-title'}
                    sx={{
                        fontFamily: 'Poppins',
                        fontSize: isScreenMd
                            ? '32px'
                            : isScreenSm
                              ? '28px'
                              : isScreenXs
                                ? '22px'
                                : '40px',
                        marginTop: '2.5rem',
                        marginBottom: '2.5rem',
                        fontWeight: 500,
                        textAlign: 'left',
                        lineHeight: '48px',
                        backgroundColor: '#F8F8F8',
                    }}
                >
                    {cmsContent.title.content}
                </Typography>
                <KsimOverview cmsContent={cmsContent} />
            </Box>
        </Box>
    );
};

export default KsimSection;
